import Storage from './Storage'
import Platform from '../Platform'

export default class App extends Platform {
  constructor() {
    super({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      vectorFormat: 'svg',
      // supportedInsertFileTypes: ['svg'],
      storage: new Storage(),
      features: {
        syncFromTool: true
      },
      info: {}
    })
  }

  // File
  // { name, url, format }
  insertItem(file) {
    console.log('insertItem', file)
  }

  insertItems(files) {
    console.log('insertItems', files)
  }

  openURL(url) {
    window.open(url)
  }

  close() {
    console.log('close')
  }

  // Myscout
  syncSelection(uuid, token) {
    alert(`Do you want to sync components?`)
  }

  getAllSelectionColors() {
    // Setting Dummy components for development in Web
    if (process.env.NODE_ENV === 'development') {
      const random = require('lodash/random')
      const shuffle = require('lodash/shuffle')
      const take = require('lodash/take')
      const dummyColors = ['red', 'green', 'yellow', 'orange', 'violet']
      window.onSelectionChanged({
        count: random(1, 10),
        colors: take(shuffle(dummyColors), random(0, 5)),
        documentColors: take(shuffle(dummyColors), random(0, 5))
      })
    }
  }
}
